import { Component, Input } from '@angular/core';
import { Moment } from 'moment';

import { getMomentAfterTime } from '../../../shared/utils/moment-date';
import {
  BukTicketContents,
  BukTicketContentsType,
  BukTicketIssueData,
} from '../../models/buk-ticket.model';

@Component({
  selector: 'app-email-ticket-preview',
  templateUrl: './email-ticket-preview.component.html',
  styleUrls: ['./email-ticket-preview.component.scss'],
})
export class EmailTicketPreviewComponent {
  @Input() contents: BukTicketContents;
  @Input() contentsType: BukTicketContentsType;
  @Input() focusedInput: string;
  @Input() isUnlimitedTicket: boolean = false;
  @Input()
  set ticketData(ticketData: BukTicketIssueData) {
    this._ticketData = ticketData;

    if (ticketData?.expiryDate) {
      if (typeof ticketData.expiryDate === 'string') {
        this.expiryDate = getMomentAfterTime(
          ticketData.expiryDate
        ).toISOString();
      } else {
        this.expiryDate = ticketData.expiryDate;
      }
    }
  }

  public _ticketData: BukTicketIssueData;
  public expiryDate: string | Moment;
}
